import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { hooksQueryOptions } from "@/app/logic-extensions/api/get-hooks";
import { pluginsQueryOptions } from "@/app/logic-extensions/api/get-plugins";
import { LogicExtensionsSkeleton } from "@/app/logic-extensions/components/logic-extensions-skeleton";
import { LogicExtensionsList } from "@/app/logic-extensions/list";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/"
)({
  component: () => (
    <Suspense fallback={<LogicExtensionsSkeleton />}>
      <LogicExtensionsList />
    </Suspense>
  ),
  beforeLoad(ctx) {
    ctx.context.queryClient.prefetchQuery(
      pluginsQueryOptions({ binding: "project", scope: ctx.params })
    );
    ctx.context.queryClient.prefetchQuery(
      hooksQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
});
